import maskCPFandCNPJ from "../util/maskCPFandCNPJ";
const ID_APLICACAO_LOJA = "FA4BDF05-C3D7-4907-A532-165730D2D89B";

export const FIELDS_CONSULTA_LOJAS_RELATORIOS_PERSONALIZADO = [
  {
    label: 'CNPJ',
    value: 'CPFCNPJ',
  },
  {
    label: 'Produto',
    value: 'Produto',
  },
  {
    label: 'Código GEFIN',
    value: 'CodigoGefin',
  },
  {
    label: 'Código Filial',
    value: 'IdFilial',
  },
  {
    label: 'Nome Representante',
    value: 'NomeRepresentanteLegal',
  },
  {
    label: 'Nome Representante 2',
    value: 'NomeRepresentanteLegal2',
  },
  {
    label: 'Data Pré-Cadastro',
    value: 'DataPreCadastro',
  },
  {
    label: "Fila",
    value: "IdFila"
  },
  {
    label: 'Data Upload',
    value: 'DataUpload',
  },
  {
    label: 'Data Tipificação - Entrada',
    value: 'DataTipificacaoEntrada',
  },
  {
    label: 'Data Tipificação - Saída',
    value: 'DataTipificacaoSaida',
  },
  {
    label: 'Data Pré-Análise - Entrada',
    value: 'DataPreanaliseEntrada',
  },
  {
    label: 'Data Pré-Análise - Saída',
    value: 'DataPreanaliseSaida',
  },
  {
    label: 'Data Análise - Entrada',
    value: 'DataAnaliseEntrada',
  },
  {
    label: 'Data Análise - Saída',
    value: 'DataAnaliseSaida',
  },
  {
    label: 'Data Análise PEL - Entrada',
    value: 'DataAnalisePelEntrada',
  },
  {
    label: 'Data Análise PEL - Saída',
    value: 'DataAnalisePelSaida',
  },
  {
    label: 'Data Cadastro - Entrada',
    value: 'DataCadastroEntrada',
  },
  {
    label: 'Data Cadastro - Saída',
    value: 'DataCadastroSaida',
  },
  {
    label: 'Data Conferência - Entrada',
    value: 'DataConferenciaEntrada',
  },
  {
    label: 'Data Conferência - Saída',
    value: 'DataConferenciaSaida',
  },
  {
    label: 'Funcional Conferência',
    value: 'FuncionalConferencia',
  },
  {
    label: 'Funcional Cadastro',
    value: 'FuncionalCadastro',
  },
  {
    label: 'Funcional Análise PEL',
    value: 'FuncionalAnalisePEL',
  },
  {
    label: 'Funcional Análise',
    value: 'FuncionalAnalise',
  },
  {
    label: 'Carteira',
    value: 'Carteira',
  },
  {
    label: 'Código Loja',
    value: 'CodigoLoja',
  },
  {
    label: 'Segmento',
    value: 'TipoLoja_Produto',
  },
  {
    label: 'Pendência',
    value: 'Pendencia',
  },
  {
    label: 'SLA Pré-Análise',
    value: 'SLAPreAnalise',
  },
  {
    label: 'SLA Análise',
    value: 'SLAAnalise',
  },
  {
    label: 'SLA PEL',
    value: 'SLAPel',
  },
  {
    label: 'SLA Cadastro',
    value: 'SLACadastro',
  },
  {
    label: 'SLA Conferência',
    value: 'SLAConferencia',
  }
];

export const FIELDS_RELATORIO_PERSONALIZADO = {
  CPFCNPJ: {
    name: 'CPFCNPJ',
    type: 'input-cpfcnpj',
    dataFormat: (cell) => maskCPFandCNPJ(cell),
    placeholder: 'CNPJ',
    label: 'CNPJ',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  Produto: {
    name: 'Produto',
    type: 'select',
    placeholder: 'Selecione um Produto',
    label: 'Produto',
    options: [
      {
        text: 'Cadastro de Loja Nova - Correspondente Bancário',
        value: 'Cadastro de Loja Nova – Correspondente Bancário',
      },
      {
        text: 'Cadastro de Loja Nova - Acordo Comercial',
        value: 'Cadastro de Loja Nova – Acordo Comercial',
      },
      {
        text: 'Cadastro de Loja Nova - Substabelecido',
        value: 'Cadastro de Loja Nova – Substabelecido',
      },
      {
        text: 'Contrato Customizado',
        value: 'Contrato Customizado',
      },
      {
        text: 'Alteração de dados cadastrais - Correspondentes',
        value: 'Alteração de dados cadastrais – Correspondentes',
      },
      {
        text: 'Alteração de dados bancários - Correspondentes',
        value: 'Alteração de dados bancários – Correspondentes',
      },
      {
        text: 'Aditivo para alteração de dados bancários - Substabelecido',
        value: 'Aditivo para alteração de dados bancários – Substabelecido',
      },
      {
        text: 'Alteração de Acordo Comercial para Correspondente Bancário',
        value: 'Alteração de Acordo Comercial para Correspondente Bancário',
      },
    ],
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  CodigoGefin: {
    name: 'CodigoGefin',
    type: 'select-autocomplete',
    placeholder: 'Selecione código Gefin',
    label: 'Código GEFIN',
    remote: {
      method: 'GET',
      service: 'mesaveic',
      path: '/pagamentoFull/dadosGefin?buscaCodigos=true',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3
  },
  IdFilial: {
    name: 'IdFilial',
    type: 'select-autocomplete',
    placeholder: 'Selecione uma filial',
    label: 'Filial',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/filiais',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  NomeRepresentanteLegal: {
    name: 'NomeRepresentanteLegal',
    type: 'text',
    placeholder: 'Nome do Representante',
    label: 'Nome Representante 1',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  NomeRepresentanteLegal2: {
    name: 'NomeRepresentanteLegal2',
    type: 'text',
    placeholder: 'Nome do Representante',
    label: 'Nome Representante 2',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  IdFila: {
    name: 'IdFila',
    type: 'select',
    placeholder: 'Selecione uma fila',
    label: 'Fila',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: "consulta/filas",
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  DataPreCadastro: {
    type: 'dateRange',
    name: 'DataPreCadastro',
    label: 'Data Pré-Cadastro',
    fields: [
      {
        name: 'DataPreCadastroInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Cadastro - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataPreCadastroFim',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Cadastro - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataUpload: {
    type: 'dateRange',
    name: 'DataUpload',
    label: 'Data Upload',
    fields: [
      {
        name: 'DataUploadInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Upload - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataUploadFim',
        type: 'date',
        placeholder: '',
        label: 'Data Upload - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataTipificacaoEntrada: {
    type: 'dateRange',
    name: 'DataTipificacaoEntrada',
    label: 'Data Tipificação - Entrada',
    fields: [
      {
        name: 'DataTipificacaoEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Tipificação Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataTipificacaoEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Tipificação Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataTipificacaoSaida: {
    type: 'dateRange',
    name: 'DataTipificacaoSaida',
    label: 'Data Tipificação - Saída',
    fields: [
      {
        name: 'DataTipificacaoSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Tipificação Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataTipificacaoSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Tipificação Saída - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataPreanaliseEntrada: {
    type: 'dateRange',
    name: 'DataPreanaliseEntrada',
    label: 'Data Pré-Análise - Entrada',
    fields: [
      {
        name: 'DataPreanaliseEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Análise Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataPreanaliseEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Análise Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataPreanaliseSaida: {
    type: 'dateRange',
    name: 'DataPreanaliseSaida',
    label: 'Data Pré-Análise - Saída',
    fields: [
      {
        name: 'DataPreanaliseSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Análise Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataPreanaliseSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Pré-Análise Saída - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataAnaliseEntrada: {
    type: 'dateRange',
    name: 'DataAnaliseEntrada',
    label: 'Data Análise - Entrada',
    fields: [
      {
        name: 'DataAnaliseEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Análise Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataAnaliseEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Análise Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataAnaliseSaida: {
    type: 'dateRange',
    name: 'DataAnaliseSaida',
    label: 'Data Análise - Saída',
    fields: [
      {
        name: 'DataAnaliseSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Análise Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataAnaliseSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Análise Saída - Final ',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataAnalisePelEntrada: {
    type: 'dateRange',
    name: 'DataAnalisePelEntrada',
    label: 'Data Análise PEL - Entrada',
    fields: [
      {
        name: 'DataAnalisePelEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Análise PEL Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataAnalisePelEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Análise PEL Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataAnalisePelSaida: {
    type: 'dateRange',
    name: 'DataAnalisePelSaida',
    label: 'Data Análise PEL - Saída',
    fields: [
      {
        name: 'DataAnalisePelSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Análise PEL Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataAnalisePelSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Análise PEL Saída - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  FuncionalAnalisePEL: {
    name: 'FuncionalAnalisePEL',
    type: 'select',
    placeholder: 'Selecione um login',
    label: 'Funcional Análise PEL',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: "usuario/getFuncional?funcional=creditoPel",
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  DataCadastroEntrada: {
    type: 'dateRange',
    name: 'DataCadastroEntrada',
    label: 'Data Cadastro - Entrada',
    fields: [
      {
        name: 'DataCadastroEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Cadastro Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataCadastroEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Cadastro Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataCadastroSaida: {
    type: 'dateRange',
    name: 'DataCadastroSaida',
    label: 'Data Cadastro - Saída',
    fields: [
      {
        name: 'DataCadastroSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Cadastro Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataCadastroSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Cadastro Saída - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  FuncionalCadastro: {
    name: 'FuncionalCadastro',
    type: 'select',
    placeholder: 'Selecione um login',
    label: 'Funcional Cadastro',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: "usuario/getFuncional?funcional=cadastro",
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  DataConferenciaEntrada: {
    type: 'dateRange',
    name: 'DataConferenciaEntrada',
    label: 'Data Conferencia - Entrada',
    fields: [
      {
        name: 'DataConferenciaEntradaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Conferência Entrada - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataConferenciaEntradaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Conferência Entrada - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  DataConferenciaSaida: {
    type: 'dateRange',
    name: 'DataConferenciaSaida',
    label: 'Data Conferência - Saída',
    fields: [
      {
        name: 'DataConferenciaSaidaInicio',
        type: 'date',
        placeholder: '',
        label: 'Data Conferência Saída - Inicial',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
      {
        name: 'DataConferenciaSaidaFim',
        type: 'date',
        placeholder: '',
        label: 'Data Conferência Saída - Final',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 3,
      },
    ],
  },
  FuncionalConferencia: {
    name: 'FuncionalConferencia',
    type: 'select',
    placeholder: 'Selecione um login',
    label: 'Funcional Conferência',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: "usuario/getFuncional?funcional=conferencia",
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  FuncionalAnalise: {
    name: 'FuncionalAnalise',
    type: 'select',
    placeholder: 'Selecione um login',
    label: 'Funcional Análise',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: "usuario/getFuncional?funcional=analise",
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  Carteira: {
    name: 'Carteira',
    type: 'select',
    placeholder: 'Selecione um carteira',
    label: 'Carteira',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: `consulta/carteiras?idAplicacaoCliente=${ID_APLICACAO_LOJA}`,
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  CodigoLoja: {
    name: 'CodigoLoja',
    type: 'select-autocomplete',
    placeholder: 'Selecione código loja',
    label: 'Código Loja',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'relatorio/filiais',
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  TipoLoja_Produto: {
    name: 'TipoLoja_Produto',
    type: 'select',
    placeholder: 'Selecione Segmento',
    label: 'Segmento',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: `consulta/segmentosTodos?idAplicacaoCliente=${ID_APLICACAO_LOJA}`,
    },
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  Pendencia: {
    name: 'Pendencia',
    type: 'select',
    placeholder: 'Selecione pendência',
    remote: {
      method: 'GET',
      service: 'consulta',
      path: 'loja/consultaGrupoDocumentalTodos',
    },
    label: 'Pendência',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  SLAPreAnalise: {
    type: 'timeRangeUnit',
    name: 'SLAAnalisePre',
    label: 'SLA Pré-Análise',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  SLAAnalise: {
    name: 'SLAAnalise',
    type: 'timeRangeUnit',
    placeholder: 'Tempo usado análise',
    label: 'SLA Análise',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  SLAPel: {
    name: 'SLAPel',
    type: 'timeRangeUnit',
    placeholder: 'Tempo usado análise',
    label: 'SLA PEL',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  SLACadastro: {
    name: 'SLACadastro',
    type: 'timeRangeUnit',
    placeholder: 'Tempo usado análise',
    label: 'SLA Cadastro',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
  SLAConferencia: {
    name: 'SLAConferencia',
    type: 'timeRangeUnit',
    placeholder: 'Tempo usado análise',
    label: 'SLA Conferência',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 3,
  },
}